<template>
  <div>
    <b-card>
      <b-card-header>
        <span class="badge-number">{{ numberItem }}</span>
        <b-row>
          <b-col cols="12" md="8" lg="8">
            <h4 class="my-0 font-weight-bold">
              <span v-if="order.isAnonymous === 'no'">{{ order.firstName }} {{ order.lastName }}</span>
              <span class="ml-4" v-if="order.isAnonymous === 'no'">
                                <span class="material-icons mr-2 align-middle" style="font-size: 18px">mail</span>
                                <small>{{ order.email }}</small>
                            </span>
            </h4>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <span class="material-icons align-middle">tag</span>
            <b-badge variant="light" style="font-size: 13px">{{ order.factor_number }}</b-badge>
            <b-badge class="float-right" variant="light" style="font-size: 13px">
              <span class="material-icons align-middle">calendar_today</span>
              {{ order.date }}
            </b-badge>
          </b-col>
        </b-row>
      </b-card-header>
      <!--END Header-->
      <b-card-body>
        <b-row>
          <b-col cols="12" md="2">

            <template>
              <template v-if="order.country === 'Österreich'">
                <img src="/images/at-logo.png" width="25">
              </template>
              <template v-else-if="order.country === 'Deutschland'">
                <img src="/images/de-logo.png" width="25">
              </template>
              <template v-else>
                <span class="material-icons align-middle">public</span>
              </template>
              <span>{{ order.country }}</span>
            </template>

          </b-col>

          <b-col cols="12" md="6">
            <template>
                            <span class="align-middle">
                            <template v-if="order.transport_value === '1'">
                            <img src="/images/de-logo.png" width="25">
                            </template>
                            <template v-else-if="order.transport_value === '6'">
                            <img src="/images/at-logo.png" width="25">
                            </template>
                            <template v-else-if="order.transport_value === '7'">
                            <img src="/images/eu-logo.png" width="25">
                            </template>
                        </span>
              <span>{{ order.transport }}</span>
            </template>

          </b-col>
          <b-col cols="12" md="4" class="text-center">
            <span class="align-middle font-weight-bold mr-2">Preis:</span>
            <span class="font-weight-bold">{{ order.price }} €</span>
            <br>
            <span class="font-weight-bold">{{ order.payment_type }}</span>
          </b-col>
        </b-row>
        <!--END Information-->

        <template v-if="order.payment !== null">
          <b-link v-b-toggle="'accordion-'+order.id">
            <span class="font-weight-bold text-info">Heidelpay</span>
          </b-link>
          <b-collapse :id="'accordion-'+order.id" visible accordion="my-accordion" role="tabpanel">
            <b-list-group>
              <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                heidelpay-id: <span>{{ order.payment.payment_heidey_id }}</span>
                <b-badge :variant="order.payment.payment_status === 'success' ? 'success' : 'warning'"
                         pill>{{ order.payment.payment_status }}
                </b-badge>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </template>
        <!--END Payment-->
        <br>

        <b-row>
          <b-col cols="12" md="8" lg="7">
            <div class="mt-3">
              <b-badge class="font-14 mr-1" v-orderStatus="order.order_status_value">{{ order.status }}
              </b-badge>
              <b-badge class="font-14" v-statusPayment="order.status_payment_value">
                {{ order.status_payment }}
              </b-badge>
            </div>

          </b-col>
          <b-col cols="12" md="4" lg="5">
            <b-link :to="{name:'OrdersPrint',params:{'orderid':order.id}}"
                    class="btn btn-outline-danger mr-1">{{ $t('printTitle') }}
            </b-link>
            <template>
              <b-link :to="{name:'OrderDetails',params:{'orderid':order.id}}" class="btn btn-success mr-1">
                {{ $t('details') }}
              </b-link>
            </template>

          </b-col>
        </b-row>
        <!--END Buttons-->


      </b-card-body>

      <b-card-footer>
        <!--<template v-if="order.isAdmin === 'yes'">
             <span class="align-middle">
                    <template>
                        <img src="/images/logo.jpg" width="25">
                    </template>
                 Überweisung
                </span>
        </template>-->


        <slot name="checkbox"></slot>
      </b-card-footer>

    </b-card>
  </div>
</template>

<script>
import {EventBus} from "../../../Services/Eventbus/event-bus";

export default {
  name: "order",
  props: {
    order: {
      type: Object,
      default: null
    },
    numberItem: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      orderIds: [],
    }
  },
  methods: {
    onSelect() {
      EventBus.$emit("orderIds", this.orderIds);
    }
  },
  directives: {
    statusPayment: {
      bind(el, binding) {
        switch (binding.value) {
          case 'init':
            el.style.backgroundColor = '#EF3B2A';
            break;
          case 'unpaid':
            el.style.backgroundColor = '#EF3B2A';
            break;
          case 'paid':
            el.style.backgroundColor = '#139E18';
            break;
          case 'posdevice':
            el.style.backgroundColor = '#139E18';
            break;
          case 'cash':
            el.style.backgroundColor = '#ffd70e';
            el.style.color = '#000';
            break;
          case 'lawyer':
            el.style.backgroundColor = '#ff0ef3';
            break;
          case 'rejectpurchaseinvoice':
            el.style.backgroundColor = '#ff8232';
            break;
          case 'paidpurchaseinvoice':
            el.style.backgroundColor = '#9bff22';
            el.style.color = '#000';
            break;
        }
      },
      update(el, binding) {
        switch (binding.value) {
          case 'init':
            el.style.backgroundColor = '#EF3B2A';
            break;
          case 'unpaid':
            el.style.backgroundColor = '#EF3B2A';
            break;
          case 'paid':
            el.style.backgroundColor = '#139E18';
            break;
          case 'posdevice':
            el.style.backgroundColor = '#139E18';
            break;
          case 'cash':
            el.style.backgroundColor = '#ffd70e';
            el.style.color = '#000';
            break;
          case 'lawyer':
            el.style.backgroundColor = '#ff0ef3';
            break;
          case 'rejectpurchaseinvoice':
            el.style.backgroundColor = '#ff8232';
            break;
          case 'paidpurchaseinvoice':
            el.style.backgroundColor = '#9bff22';
            el.style.color = '#000';
            break;
        }
      }
    },
    orderStatus: {
      bind(el, binding) {
        switch (binding.value) {
          case 'pending':
            el.style.backgroundColor = '#EF3B2A';
            break;
          case 'pickedup':
            el.style.backgroundColor = '#1da1f2';
            el.style.color = '#fff';
            break;
          case 'ready':
            el.style.backgroundColor = '#1da1f2';
            el.style.color = '#fff';
            break;
          case 'posted':
            el.style.backgroundColor = '#139E18';
            break;
          case 'reviewed':
            el.style.backgroundColor = '#9c27b0';
            break;
          case 'return_request':
            el.style.backgroundColor = '#00bcd4';
            el.style.color = '#fff';
            break;
          case 'return_accept':
            el.style.backgroundColor = '#00bcd4';
            el.style.color = '#fff';
            break;
          case 'cancel':
            el.style.backgroundColor = '#000000';
            break;
          default:
            el.style.backgroundColor = '#ffd70e';
            break;
        }
      },
      update(el, binding) {
        switch (binding.value) {
          case 'pending':
            el.style.backgroundColor = '#EF3B2A';
            break;
          case 'pickedup':
            el.style.backgroundColor = '#1da1f2';
            el.style.color = '#fff';
            break;
          case 'ready':
            el.style.backgroundColor = '#1da1f2';
            el.style.color = '#fff';
            break;
          case 'posted':
            el.style.backgroundColor = '#139E18';
            break;
          case 'reviewed':
            el.style.backgroundColor = '#9c27b0';
            break;
          case 'return_request':
            el.style.backgroundColor = '#00bcd4';
            el.style.color = '#fff';
            break;
          case 'return_accept':
            el.style.backgroundColor = '#00bcd4';
            el.style.color = '#fff';
            break;
          case 'cancel':
            el.style.backgroundColor = '#000000';
            break;
          default:
            el.style.backgroundColor = '#ffd70e';
            break;
        }
      }
    },
  },
}
</script>

<style scoped>
.badge-number {
  min-width: 35px;
  min-height: 35px;
  background-color: #f1f1f1;
  display: inline-block;
  border-radius: 55px;
  text-align: center;
  padding: 7px 10px;
  font-size: 22px;
  margin-bottom: 18px;
  font-weight: bold;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.2);
}
</style>